import { render, staticRenderFns } from "./BrightStore.vue?vue&type=template&id=c1cbc42c"
import script from "./BrightStore.vue?vue&type=script&lang=js"
export * from "./BrightStore.vue?vue&type=script&lang=js"
import style1 from "./BrightStore.vue?vue&type=style&index=1&id=c1cbc42c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports